/* eslint-disable max-statements */
/* eslint-disable complexity */
const PostalAddressDetail = () =>
    import(/* webpackChunkName: "IntervenerDetailRelated" */ '@/components/interveners/postal-address-detail');

import DatePickerMixin from '@/mixins/datepicker';
import formatData from '@/mixins/formatData';

export default {
    name: 'AccountFiscalData',

    mixins: [DatePickerMixin, formatData],

    components: {
        PostalAddressDetail
    },

    /**
     * @override
     */
    data() {
        return {
            addresses: null,
            addressesTable: {
                items: [],
                fields: [
                    {
                        key: 'radiobutton',
                        label: ''
                    },
                    {
                        key: 'intervener',
                        label: 'Interviniente'
                    },
                    {
                        key: 'f_address_street_1',
                        label: 'Domicilio'
                    },
                    {
                        key: 'f_address_street_2',
                        label: 'Información adicional'
                    },
                    {
                        key: 'f_address_number',
                        label: 'Número'
                    },
                    {
                        key: 'f_address_floor',
                        label: 'Planta'
                    },
                    {
                        key: 'f_address_door',
                        label: 'Puerta'
                    },
                    {
                        key: 'f_address_postal_code',
                        label: 'Código postal'
                    },
                    {
                        key: 'f_address_city',
                        label: 'Localidad'
                    },
                    {
                        key: 'f_address_key_state',
                        label: 'Provincia/Región'
                    },
                    {
                        key: 'f_address_key_country',
                        label: 'Pais'
                    }
                ]
            },
            vissibilityCollapse1: true,
            detailsEdit: false,
            collapsed: true,
            uuid_intervener_tax_address: null
        };
    },
    props: {
        uuid: {
            type: String,
            required: false
        },
        creation: {
            type: Boolean,
            required: false
        },
        data: {
            type: Array,
            required: false
        },
        loading: {
            type: Boolean,
            required: false
        }
    },
    watch: {
        /**
         * Actualizar registro de la tabla ante cambios en data
         */
        data() {
            this.formatData();
        }
    },
    methods: {
        /**
         * Formatea el objeto data
         */
        formatData() {
            if (!this.data || !Array.isArray(this.data) || this.data.length < 1) {
                this.addressesTable.items = [];
                return;
            }
            this.addressesTable.items = this.data.map(i => i);
            this.uuid_intervener_tax_address =  this.data[0].uuid_intervener_tax_address
                || this.data[0].uuid_intervener;
        },

        /**
         * Al cambiar el valor se guarda la nueva direccion fiscal de la cuenta
         * @param {String} v Interviniente
         */
        changeAddress(v) {
            const payload = {
                uuid_intervener_tax_address: v
            };
            this.$emit('change', v);

            if (this.creation) {
                const address = this.addressesTable.items.find(x => x.uuid_intervener === v);
                this.$root.$emit('changeFiscalAddress', address);
                return;
            }
            this.$accountsService
                .updateAccountInfo(this.uuid, payload)
                .then(() => {
                    this.$toast.success(`Guardado`, `Datos modificados con éxito.`);
                })
                .catch(err => {
                    this.$toast.error(err.name, err.message);
                });
        },

        /**
         * Comprueba que se ha seleccionado un dirección fiscal
         * @return {*} validacion
         */
        validateData() {
            return Promise.resolve(!!this.uuid_intervener_tax_address);
        },

        /**
         * Comprueba que se ha seleccionado un dirección fiscal
         * @return {*} valor validado
         */
        fetchValidatedData() {
            return this.validateData().then(valid => (valid ? this.uuid_intervener_tax_address : undefined));
        },
        constructFullName(intervener) {
            let name = intervener.name ? `${intervener.name}` : '';
            name += intervener.lastname_1 ? ` ${intervener.lastname_1}` : '';
            name += intervener.lastname_2 ? ` ${intervener.lastname_2}` : '';
            name = name.trim();
            return name;
        }
    }
};
